export enum UserType {
    DEVELOPER = "DEVELOPER",
    INTERNAL = "INTERNAL",
    EXTERNAL = "EXTERNAL",
    MICROROLE = "MICROROLE",
}
